var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-combo-box',{attrs:{"label":_vm.label,"data-set":_vm.dataset,"selectedItems":_vm.selectedItems,"error":_vm.error,"error-text":_vm.errorText},on:{"input":_vm.Onchange}})
}
var staticRenderFns = []

export { render, staticRenderFns }